import * as actionTypes from '../actions/actionTypes'

const initialState = {

    companies: [],
    competencyScoreGroupOptions: [],
    competencyScores: [],
    competencyScoresGroup: [],
    structures: [],
    loadingStates: [],
    loading: false,
    modalLoading: false,
    selectedRecord: null,
    selectedRecordScore: null,
    filtered: false,
    filterLoading: false,
    selectedRecordLoading: false,
    success: false
}

// competency score group
const fetchCompetencyScoreGroupStart = (state, action) => {
    return {
        ...state,
        loading: true,
        filterLoading: true,
        filtered: false
    }
}

const fetchCompetencyScoreGroupSuccess = (state, action) => {
    return {
        ...state,
        filtered: true,
        filterLoading: false,
        loading: false,
        competencyScoresGroup: action.records
    }
}

const fetchCompetencyScoreGroupFailed = (state, action) => {
    return {
        ...state,
        loading: false,
        filtered: false,
        filterLoading: false,
        message: action.errorMessage,
    }
}

const fetchCompetencyScoreGroupByIdStart = (state, action) => {
    return {
        ...state,
        filterLoading: true,
        filtered: false
    }
}

const fetchCompetencyScoreGroupByIdSuccess = (state, action) => {
    return {
        ...state,
        loading: false,
        filtered: true,
        filterLoading: false,
        selectedRecord: action.recordData
    }
}

const fetchCompetencyScoreGroupByIdFailed = (state, action) => {
    return {
        ...state,
        filtered: false,
        filterLoading: false,
        selectedRecord: null,
        message: action.errorMessage
    }
}

const createCompetencyScoreGroupStart = (state, action) => {
    return {
        ...state,
        modalLoading: true,
        success: false
    }
}

const createCompetencyScoreGroupSuccess = (state, action) => {
    return {
        ...state,
        modalLoading: false,
        message: action.message,
        success: true
    }
}

const createCompetencyScoreGroupFailed = (state, action) => {
    return {
        ...state,
        modalLoading: false,
        success: false
    }
}

const updateCompetencyScoreGroupStart = (state, action) => {
    return { ...state, modalLoading: true, success: false }
}

const updateCompetencyScoreGroupSuccess = (state, action) => {
    return {
        ...state,
        modalLoading: false,
        success: true,
        message: action.message
    }
}

const updateCompetencyScoreGroupFailed = (state, action) => {
    return {
        ...state,
        modalLoading: false,
        message: action.errorMessage,
        success: false
    }
}

const deleteCompetencyScoreGroupStart = (state, action) => {
    return { ...state, modalLoading: true, loading: true }
}

const deleteCompetencyScoreGroupSuccess = (state, action) => {
    return {
        ...state,
        modalLoading: false,
        success: true,
        message: action.message
    }
}

const deleteCompetencyScoreGroupFailed = (state, action) => {
    return {
        ...state,
        modalLoading: false,
        success: false,
        message: action.errorMessage
    }
}

const clearSelectedCompetencyScoreGroupRecord = (state, action) => {
    return {
        ...state,
        selectedRecord: null,
        success: false
    }
}


// competency score
const fetchCompetencyScoreStart = (state, action) => {
    return {
        ...state,
        // loadingStates: [...state.loadingStates, 'records']
        loading: true
    }
}

const fetchCompetencyScoreSuccess = (state, action) => {
    return {
        ...state,
        // loadingStates: state.loadingStates.filter(item => item !== 'records'),
        competencyScores: action.records,
        loading: false
    }
}

const fetchCompetencyScoreFailed = (state, action) => {
    return {
        ...state,
        // loadingStates: state.loadingStates.filter(item => item !== 'records')
        loading: false
    }
}

const fetchCompetencyScoreByIdStart = (state, action) => {
    return {
        ...state,
        selectedRecordLoading: true
    }
}

const fetchCompetencyScoreByIdSuccess = (state, action) => {
    return {
        ...state,
        selectedRecordLoading: false,
        selectedRecordScore: action.recordData
    }
}

const fetchCompetencyScoreByIdFailed = (state, action) => {
    return {
        ...state,
        selectedRecordScore: null,
        selectedRecordLoading: false,
        message: action.errorMessage
    }
}

const createCompetencyScoreStart = (state, action) => {
    return {
        ...state,
        modalLoading: true,
        success: false
    }
}

const createCompetencyScoreSuccess = (state, action) => {
    return {
        ...state,
        modalLoading: false,
        message: action.message,
        success: true
    }
}

const createCompetencyScoreFailed = (state, action) => {
    return {
        ...state,
        modalLoading: false,
        success: false,
        message: action.message
    }
}

const updateCompetencyScoreStart = (state, action) => {
    return { ...state, modalLoading: true, success: false }
}

const updateCompetencyScoreSuccess = (state, action) => {
    return {
        ...state,
        modalLoading: false,
        success: true,
        message: action.message
    }
}

const updateCompetencyScoreFailed = (state, action) => {
    return {
        ...state,
        modalLoading: false,
        message: action.errorMessage,
        success: false
    }
}

const deleteCompetencyScoreStart = (state, action) => {
    return { ...state, modalLoading: true }
}

const deleteCompetencyScoreSuccess = (state, action) => {
    return {
        ...state,
        modalLoading: false,
        success: true,
        message: action.message
    }
}

const deleteCompetencyScoreFailed = (state, action) => {
    return {
        ...state,
        modalLoading: false,
        success: false,
        message: action.errorMessage
    }
}

const clearSelectedCompetencyScoreRecord = (state, action) => {
    return {
        ...state,
        selectedRecordScore: null
    }
}

const fetchCompetencyScoreGroupOptionsStart = state => {
    return {
        ...state
    }
}

const fetchCompetencyScoreGroupOptionsSuccess = (state, action) => {
    return {
        ...state,
        competencyScoreGroupOptions: action.data
    }
}

const fetchCompetencyScoreGroupOptionsFailed = (state, action) => {
    return {
        ...state,
        message: action.errorMessage
    }
}

const fetchStructureOptionsStart = (state, action) => {
    return { ...state, loading: true }
}

const fetchStructureOptionsSuccess = (state, action) => {
    return {
        ...state,
        filterStructure: action.data,
        loading: false,
    }
}

const fetchStructureOptionsFailed = (state, action) => {
    return {
        ...state,
        loading: false
    }
}

const fetchCompanyStart = (state, action) => {
    return { ...state, loading: true }
}

const fetchCompanySuccess = (state, action) => {
    return {
        ...state,
        loading: false,
        companies: action.data
    }
}

const fetchCompanyFailed = (state, action) => {
    return {
        ...state,
        loading: false,
        message: action.errorMessage
    }
}

const reducer = (state = initialState, action) => {
    switch (action.type) {
        //competency score group
        case actionTypes.FETCH_COMPETENCY_SCORE_GROUP_START:
            return fetchCompetencyScoreGroupStart(state, action)
        case actionTypes.FETCH_COMPETENCY_SCORE_GROUP_SUCCESS:
            return fetchCompetencyScoreGroupSuccess(state, action)
        case actionTypes.FETCH_COMPETENCY_SCORE_GROUP_FAILED:
            return fetchCompetencyScoreGroupFailed(state, action)
        case actionTypes.FETCH_COMPETENCY_SCORE_GROUP_BY_ID_START:
            return fetchCompetencyScoreGroupByIdStart(state, action)
        case actionTypes.FETCH_COMPETENCY_SCORE_GROUP_BY_ID_SUCCESS:
            return fetchCompetencyScoreGroupByIdSuccess(state, action)
        case actionTypes.FETCH_COMPETENCY_SCORE_GROUP_BY_ID_FAILED:
            return fetchCompetencyScoreGroupByIdFailed(state, action)
        case actionTypes.CLEAR_SELECTED_COMPETENCY_SCORE_GROUP_RECORD:
            return clearSelectedCompetencyScoreGroupRecord(state, action)
        case actionTypes.CREATE_COMPETENCY_SCORE_GROUP_START:
            return createCompetencyScoreGroupStart(state, action)
        case actionTypes.CREATE_COMPETENCY_SCORE_GROUP_SUCCESS:
            return createCompetencyScoreGroupSuccess(state, action)
        case actionTypes.CREATE_COMPETENCY_SCORE_GROUP_FAILED:
            return createCompetencyScoreGroupFailed(state, action)
        case actionTypes.UPDATE_COMPETENCY_SCORE_GROUP_START:
            return updateCompetencyScoreGroupStart(state, action)
        case actionTypes.UPDATE_COMPETENCY_SCORE_GROUP_SUCCESS:
            return updateCompetencyScoreGroupSuccess(state, action)
        case actionTypes.UPDATE_COMPETENCY_SCORE_GROUP_FAILED:
            return updateCompetencyScoreGroupFailed(state, action)
        case actionTypes.DELETE_COMPETENCY_SCORE_GROUP_START:
            return deleteCompetencyScoreGroupStart(state, action)
        case actionTypes.DELETE_COMPETENCY_SCORE_GROUP_SUCCESS:
            return deleteCompetencyScoreGroupSuccess(state, action)
        case actionTypes.DELETE_COMPETENCY_SCORE_GROUP_FAILED:
            return deleteCompetencyScoreGroupFailed(state, action)
        //competency score
        case actionTypes.FETCH_COMPETENCY_SCORE_START:
            return fetchCompetencyScoreStart(state, action)
        case actionTypes.FETCH_COMPETENCY_SCORE_SUCCESS:
            return fetchCompetencyScoreSuccess(state, action)
        case actionTypes.FETCH_COMPETENCY_SCORE_FAILED:
            return fetchCompetencyScoreFailed(state, action)
        case actionTypes.FETCH_COMPETENCY_SCORE_BY_ID_START:
            return fetchCompetencyScoreByIdStart(state, action)
        case actionTypes.FETCH_COMPETENCY_SCORE_BY_ID_SUCCESS:
            return fetchCompetencyScoreByIdSuccess(state, action)
        case actionTypes.FETCH_COMPETENCY_SCORE_BY_ID_FAILED:
            return fetchCompetencyScoreByIdFailed(state, action)
        case actionTypes.CLEAR_SELECTED_COMPETENCY_SCORE_RECORD:
            return clearSelectedCompetencyScoreRecord(state, action)
        case actionTypes.CREATE_COMPETENCY_SCORE_START:
            return createCompetencyScoreStart(state, action)
        case actionTypes.CREATE_COMPETENCY_SCORE_SUCCESS:
            return createCompetencyScoreSuccess(state, action)
        case actionTypes.CREATE_COMPETENCY_SCORE_FAILED:
            return createCompetencyScoreFailed(state, action)
        case actionTypes.UPDATE_COMPETENCY_SCORE_START:
            return updateCompetencyScoreStart(state, action)
        case actionTypes.UPDATE_COMPETENCY_SCORE_SUCCESS:
            return updateCompetencyScoreSuccess(state, action)
        case actionTypes.UPDATE_COMPETENCY_SCORE_FAILED:
            return updateCompetencyScoreFailed(state, action)
        case actionTypes.DELETE_COMPETENCY_SCORE_START:
            return deleteCompetencyScoreStart(state, action)
        case actionTypes.DELETE_COMPETENCY_SCORE_SUCCESS:
            return deleteCompetencyScoreSuccess(state, action)
        case actionTypes.DELETE_COMPETENCY_SCORE_FAILED:
            return deleteCompetencyScoreFailed(state, action)
        case actionTypes.FETCH_COMPETENCY_SCORE_GROUP_OPTIONS_START:
            return fetchCompetencyScoreGroupOptionsStart(state, action)
        case actionTypes.FETCH_COMPETENCY_SCORE_GROUP_OPTIONS_SUCCESS:
            return fetchCompetencyScoreGroupOptionsSuccess(state, action)
        case actionTypes.FETCH_COMPETENCY_SCORE_GROUP_OPTIONS_FAILED:
            return fetchCompetencyScoreGroupOptionsFailed(state, action)
        case actionTypes.FETCH_COMPANY_OPTIONS_START:
            return fetchCompanyStart(state, action)
        case actionTypes.FETCH_COMPANY_OPTIONS_SUCCESS:
            return fetchCompanySuccess(state, action)
        case actionTypes.FETCH_COMPANY_OPTIONS_FAILED:
            return fetchCompanyFailed(state, action)


        case actionTypes.FETCH_STRUCTURE_OPTIONS_FOR_APPRAISAL_START:
            return fetchStructureOptionsStart(state, action)
        case actionTypes.FETCH_STRUCTURE_OPTIONS_FOR_APPRAISAL_SUCCESS:
            return fetchStructureOptionsSuccess(state, action)
        case actionTypes.FETCH_STRUCTURE_OPTIONS_FOR_APPRAISAL_FAILED:
            return fetchStructureOptionsFailed(state, action)
        default:
            return state
    }
}

export default reducer
